import { render, staticRenderFns } from "./BrandedCoin.vue?vue&type=template&id=0034851a&scoped=true&"
import script from "./BrandedCoin.vue?vue&type=script&lang=ts&"
export * from "./BrandedCoin.vue?vue&type=script&lang=ts&"
import style0 from "./BrandedCoin.vue?vue&type=style&index=0&id=0034851a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0034851a",
  null
  
)

export default component.exports